import SuperagentBase from '../shared/superagent-base';

export default class AddressLookupResource extends SuperagentBase {
    getAddresses(token, query) {
        const cleanedQuery = query.replace(/[^\w\s]|_/g, ' ').replace(/\s+/g, ' ');
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/primes/addressLookup?query=${cleanedQuery}`)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/files/addresslookup-resource.js